module.exports = __webpack_public_path__ + "img/djfb-bg.9348fe39.jpg";